import { useEffect, useRef, useState } from 'react';

export default function PhilosophyHero() {
  const contentRef = useRef<HTMLDivElement>(null);
  const [zoomed, setZoomed] = useState(false);

  useEffect(() => {
    // ズームアウトアニメーション開始
    const zoomTimer = setTimeout(() => setZoomed(true), 50);

    // テキストフェードイン（0.3秒遅延）
    const textTimer = setTimeout(() => {
      contentRef.current?.querySelectorAll('.hero-item').forEach((el) => {
        el.classList.add('visible');
      });
    }, 300);

    return () => {
      clearTimeout(zoomTimer);
      clearTimeout(textTimer);
    };
  }, []);

  const heroImg = 'https://storage.readdy-site.link/project_files/09a54131-216a-4072-9e63-b291d2467f8d/00f17115-972e-465f-bb60-a074853cce27_s-2427x1536_v-frms_webp_93725884-e49e-4762-ad6b-2f546d742554.png?v=b8ea602a288df64024f72a5e947c9f23';

  return (
    <section className="relative pt-24 pb-16 px-6 min-h-[480px] md:min-h-[600px] flex items-center overflow-hidden">
      {/* 画像プリフェッチ用（非表示） */}
      <img src={heroImg} alt="" aria-hidden="true" className="hidden" fetchPriority="high" />

      {/* 背景画像 ズームアウトアニメーション */}
      <div
        className="absolute inset-0 bg-cover bg-center transition-transform ease-out"
        style={{
          backgroundImage: `url(${heroImg})`,
          transform: zoomed ? 'scale(1)' : 'scale(1.1)',
          transitionDuration: '8000ms',
        }}
      />

      {/* 黒オーバーレイ */}
      <div className="absolute inset-0 bg-black/40" />

      {/* テキスト：左下配置 */}
      <div className="absolute bottom-0 left-0 right-0 z-10 pb-10 px-6">
        <div className="max-w-6xl mx-auto flex justify-end">
          <div ref={contentRef} className="text-right max-w-xl">
            <h1
              className="hero-item text-2xl md:text-4xl font-bold text-white leading-tight drop-shadow-lg"
              style={{
                fontFamily: 'Noto Serif JP, serif',
                opacity: 0,
                transform: 'translateY(20px)',
                transition: 'opacity 1s ease, transform 1s ease',
                transitionDelay: '0.3s',
              }}
            >
              <span className="block whitespace-nowrap">さいわいデンタルクリニックの</span>
              <span className="block whitespace-nowrap">治療に対する考え方</span>
            </h1>
          </div>
        </div>
      </div>

      <style>{`
        .hero-item.visible {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>
    </section>
  );
}
